module.exports = __webpack_public_path__ + "img/flag_222.be61a35a.png";